<template>
<div class="contents">
  <admin adminType="staff"/>
</div>
</template>
<script>
import Admin from './../Admin/AdminMaintenance.vue'
export default {
	name: 'staff-maintenance',
  components: {
    Admin
  }
}
</script>